import { render, staticRenderFns } from "./vc-year-select.vue?vue&type=template&id=64237f4f&scoped=true&"
import script from "./vc-year-select.vue?vue&type=script&lang=js&"
export * from "./vc-year-select.vue?vue&type=script&lang=js&"
import style0 from "./vc-year-select.vue?vue&type=style&index=0&id=64237f4f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64237f4f",
  null
  
)

export default component.exports